import React, { useReducer } from 'react';
import reducer from './Reducer';
import actions from './Actions';

const initialValue = {
  invoices: null,
};

const context = React.createContext();

function Context({ children }) {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <context.Provider value={{ state, dispatch, actions }}>
      {children}
    </context.Provider>
  );
}

export const useContext = () => React.useContext(context);
export default Context;
